module.exports = __webpack_public_path__ + "media/small/real_estate_townhomes_rent-small-3028b93c.jpeg";